import React, { useState, useEffect, use } from 'react';
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Divider
} from '@mui/material';
import { VideoLibrary } from '@mui/icons-material';
import { PlayArrow, CheckCircle, Schedule } from '@mui/icons-material';
import { addSelectedTemplate, getAllTemplates, getOrganizationTemplateById } from '../../apis/apiList/templateApi';
import { useApp } from '../../context/AppContext';
import { useMessage } from '../../context/MessageContext';
import { BeatLoader } from 'react-spinners';
import theme from '../../theme/theme';

const Templates = () => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [lastSelectionDate, setLastSelectionDate] = useState(null);
  const [canSelectTemplate, setCanSelectTemplate] = useState(true);
  const [orgDetails, setOrgDetails] = useState(null);
  const [openVideoDialog, setOpenVideoDialog] = useState(false);
  const [selectedVideoSrc, setSelectedVideoSrc] = useState('');
  const [currentTemplate, setCurrentTemplate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const {userDetails} = useApp();
  const {showMessage} = useMessage();

  // useEffect(() => {

  //   async function fetchTemplates() {
  //     try {
  //       const templateList = await getAllTemplates({
  //         headers: {
  //           'Content-Type': 'multipart/form-data',
  //           "x-access-token": userDetails?.jwtToken || ''
  //         }
  //       })
  //       console.log('templateList', templateList);
  //       setTemplates(templateList.templates);
  //     } catch (error) {
  //       console.error('Error fetching templates:', error);
  //       showMessage('error', 'Failed to fetch templates');
  //     }
  //   }

  //   fetchTemplates();

  //   // Check if user can select template (15-day cooldown)
  //   const lastSelection = localStorage.getItem('lastTemplateSelection');
  //   if (lastSelection) {
  //     const daysDiff = Math.floor((Date.now() - parseInt(lastSelection)) / (1000 * 60 * 60 * 24));
  //     setCanSelectTemplate(daysDiff >= 15);
  //     setLastSelectionDate(new Date(parseInt(lastSelection)).toLocaleDateString());
  //   }
  // }, []);
  useEffect(() => {
    const headers = {
      'Content-Type': 'multipart/form-data',
      'x-access-token': userDetails?.jwtToken || ''
    };

    async function fetchAll() {
      setIsLoading(true)
      try {
        const [res, templateList] = await Promise.all([
          getOrganizationTemplateById(userDetails.orgId, {headers}),
          getAllTemplates({ headers }),
        ]);
        console.log('templateList', templateList);
        console.log('res', res);
        setTemplates(templateList.templates);
        setCanSelectTemplate(!res.organization.lockTemplateSelection);
        setOrgDetails(res.organization);
        setCurrentTemplate(res?.organization?.templateId || null);
        setIsLoading(false);
      } catch (error) {
        console.error('Error in fetching:', error);
        showMessage('error', 'Failed to fetch data');
        setIsLoading(false);
      }

      // const lastSelection = localStorage.getItem('lastTemplateSelection');
      // if (lastSelection) {
      //   const daysDiff = Math.floor((Date.now() - parseInt(lastSelection)) / (1000 * 60 * 60 * 24));
      //   setCanSelectTemplate(daysDiff >= 15);
      //   setLastSelectionDate(new Date(parseInt(lastSelection)).toLocaleDateString());
      // }
    }

    fetchAll();
  }, []);

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    setDialogOpen(true);
  };

  const confirmSelection = async() => {
    if (selectedTemplate && canSelectTemplate) {
      try {
        // localStorage.setItem('selectedTemplate', JSON.stringify(selectedTemplate));
        // localStorage.setItem('lastTemplateSelection', Date.now().toString());
        const res = await addSelectedTemplate({orgId: userDetails.orgId, templateId: selectedTemplate._id}, {headers: {'x-access-token': userDetails?.jwtToken || ''}});
        console.log('res after select', res);
        setCanSelectTemplate(!res?.organization?.lockTemplateSelection);
        setCurrentTemplate(res?.organization?.templateId || null);
        setOrgDetails(res.organization);
        // setLastSelectionDate(new Date().toLocaleDateString());
        setDialogOpen(false);
        console.log('Template selected:', selectedTemplate.name);
      } catch (error) {
        console.error('Error selecting template:', error);
        showMessage('error', 'Failed to select template');
      }
    }
  };

  if(isLoading) {
    return (
      <Box sx={{ textAlign: 'center', mt: 5 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <BeatLoader
            color={theme.palette.primary.main}
            loading={isLoading}
            size={25}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box mb={4}>
      <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
        Video Templates
      </Typography>

      {currentTemplate && (
          <Alert 
            severity="info" 
            sx={{ mb: 3 }}
            icon={<CheckCircle />}
          >
            Current active template: <strong style={{ textTransform: 'uppercase'}}>{currentTemplate.title}</strong> &nbsp;
            {/* {!canSelectTemplate && lastSelectionDate && (
              <span> • Next selection available after 15 days from {lastSelectionDate}</span>
            )} */}
            {/* {!canSelectTemplate && orgDetails?.lockTemplateSelection && (
              <span> • You'll be able to select a new template when your next project will start.</span>
            )} */}
          </Alert>
        )
      }

      {!canSelectTemplate && orgDetails?.lockTemplateSelection && (
        <Alert 
          severity="warning" 
          sx={{ mb: 3 }}
          icon={<Schedule />}
        >
          {/* Template selection is on cooldown. You can select a new template 15 days after your last selection. */}
          You'll be able to select a new template when your next project will start
        </Alert>
      )}

      
      {templates.length == 0 && !isLoading ? (
        <Box
          sx={{
            textAlign: 'center',
            py: 8,
            px: 2,
            mt: 5,
            borderRadius: 2,
            backgroundColor: '#f9f9f9',
            border: '1px dashed #ccc',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <VideoLibrary sx={{ fontSize: 64, color: 'grey.400', mb: 2 }} />
          <Typography variant="h6" color="text.primary" sx={{ mb: 1 }}>
            No templates available
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 450 }}>
            Templates will appear here once available. Please check back later.
          </Typography>
        </Box>  
      )
        :
        <Grid container spacing={3}>
          {templates.map((template) => (
            <Grid item xs={12} sm={6} md={4} key={template._id}>
              <Card 
                sx={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  border: '1px solid gainsboro',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
              >
                <Box
                  sx={{ position: 'relative', cursor: 'pointer' }}
                  onClick={() => {
                    setSelectedVideoSrc(template.videoId); // or template.videoUrl
                    setOpenVideoDialog(true);
                  }}
                >
                  <Box
                    sx={{
                      position: 'relative',
                      width: '100%',
                      paddingTop: '56.25%', // 16:9 aspect ratio
                      maxHeight: 325,
                      borderTopLeftRadius: 4,
                      borderTopRightRadius: 4,
                      overflow: 'hidden',
                    }}
                  >
                    <iframe
                      src={`https://player.vimeo.com/video/${template.videoId}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                      }}
                    ></iframe>
                  </Box>
                  {/* <video
                    src={template.videoId}
                    muted
                    playsInline
                    style={{
                      width: '100%',
                      maxHeight: 325,
                      objectFit: 'cover',
                      borderTopLeftRadius: 4,
                      borderTopRightRadius: 4
                    }}
                  /> */}
                  {/* <iframe
                    src={`https://player.vimeo.com/video/${template.videoId}`}
                    frameBorder="0"
                    width= '100%'
                    maxHeight= '325'
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe> */}
                  {/* <Box
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      bgcolor: 'rgba(0,0,0,0.6)',
                      borderRadius: '50%',
                      p: 1.2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <PlayArrow sx={{ color: 'white', fontSize: 32 }} />
                  </Box> */}
                </Box>
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="h6" component="h2" gutterBottom sx={{ fontWeight: 'semibold', fontSize: '16px', textTransform: 'capitalize' }}>
                    {template.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1, mb: 2 }}>
                    {template.description}
                  </Typography>
                  <Button
                    variant={currentTemplate?._id === template._id ? "outlined" : "contained"}
                    fullWidth
                    onClick={() => handleTemplateSelect(template)}
                    disabled={!canSelectTemplate && currentTemplate?._id !== template._id}
                    startIcon={currentTemplate?._id === template._id ? <CheckCircle /> : null}
                    sx={{ mt: 'auto' }}
                  >
                    {currentTemplate?._id === template._id ? 'Currently Active' : 'Select Template'}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      }


      <Dialog open={openVideoDialog} onClose={() => setOpenVideoDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Preview</DialogTitle>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center' }}>
          <video controls autoPlay style={{ width: '100%', borderRadius: 8 }}>
            <source src={selectedVideoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenVideoDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontSize: 16 }}>Confirm Template Selection</DialogTitle>
        <Divider />
        <DialogContent>
          <Typography gutterBottom>
            Are you sure you want to select "{selectedTemplate?.title}" as your template?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {/* This template will be applied to all your projects. You won't be able to change it for 15 days after selection. */}
            This template will be applied to all your projects. You won’t be able to change it until your next project starts.
          </Typography>
        </DialogContent>
        <DialogActions sx={{padding: '20px 24px', paddingTop: 0}}>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={confirmSelection} variant="contained" disabled={!canSelectTemplate}>
            Confirm Selection
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Templates;